export const WechatMassCouponApi = 'wx/wechatmasscoupon/' // 获得店铺微信优惠券
export const WechatMassCouponRevApi = 'wx/wechatmasscouponrev/' // 会员领取微信优惠券